// extracted by mini-css-extract-plugin
module.exports = {"scaleWidth":"1920px"};